export default __webpack_public_path__ + "static/media/b-1.1.6c99f9f0.jpg";